export type PhoneOS = 'android' | 'ios' | 'macOS' | 'windows' | 'unknown';

declare const window: Window &
  typeof globalThis & {
    MSStream: {};
  };

export function getOsFromUserAgent(UA?: string): PhoneOS {
  if (UA === undefined) {
    return 'unknown';
  }

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(UA)) {
    return 'windows';
  }

  if (/android/i.test(UA)) {
    return 'android';
  }

  if (/iP(ad|hone|od)/.test(UA) && !window.MSStream) {
    return 'ios';
  }

  return 'unknown';
}
